module.exports = __webpack_public_path__ + "static/img/banner_17.07b39a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_17.png
// module id = UO9I
// module chunks = 16